// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeFormat-module__root__31OCk"};